// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel-3d-slide[data-v-b1d600ac]{background:none;display:block;box-sizing:border-box}.carousel-3d-container[data-v-b1d600ac]{margin:0}", ""]);
// Exports
module.exports = exports;
